import { axiosInstance } from "./axiosInstance";

export const getBanners = async (
    page = "1",
    type = ""
) => {

    try {
        
        const bannerList = (
            await axiosInstance.get("banner", {
                params: {page, type}
            })
        ).data;
        if(bannerList && bannerList.data) {
            return bannerList.data;
        }
        return [];

    } catch (error) {
        return [];
    }

}

export const updateBanner = async (data) => {
  try {
    const updatedBanner = await axiosInstance.post("/banner/update", data);

    if (updatedBanner) {
      return updatedBanner;
    }

    return [];
  } catch (error) {
    throw error;
  }
}

export const createBanner = async (data) => {
  try {
    const createdBanner = await axiosInstance.post("/banner/post", data);

    if (createdBanner) {
      return createdBanner;
    }

    return [];
  } catch (error) {
    throw error
  }
}

export const deleteBanner = async (id) => {
  try {
    const deletedBanner = await axiosInstance.delete(`/banner/delete/${id}`);

    if (deletedBanner) {
      return deletedBanner;
    }

    return [];
  } catch (error) {
    throw error
  }
}